import { Component } from '@angular/core';
import { NavController,  ViewController, Config, AlertController,} from 'ionic-angular';

import { UserMyRadiant as User, PermitProvider, Me, RepositoryMyRadiant, HelperMyRadiant } from '@providers/index';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { Camera,CameraOptions } from '@ionic-native/camera';
import { Base64 } from "@ionic-native/base64";

import { File } from '@ionic-native/file';
import { FileChooser } from '@ionic-native/file-chooser';
import { FilePath } from '@ionic-native/file-path';
import * as mapboxgl from 'mapbox-gl';
import { Geolocation } from '@ionic-native/geolocation';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { AppActivity } from '@pages/activity';
import { Api } from '@providers/api/api';

@Component({
  selector: 'activity-ubah',
  templateUrl: 'page.html'
})
export class UbahActivity {
  loading : any;
  parameter = {
    jarak : '0',
    img_binary:null,
    file_name:null,
    location:null,
    change_picture : false,
    title:'',
    client:'',
    description:'',
    id:this.userApi.data.Employee_ID,
    code:this.userApi.data.NIK,
    name:this.userApi.data.Nama_Karyawan,
  };
  data = {
    listType:[{}],
    preview_img : './assets/img/no_img.jpg',
    style : 'mapbox://styles/mapbox/outdoors-v9',
    user:{
      lat : 0,
      lng : 0,
    },
    kantor : {
      lat:-6.240275,
      lng:106.819667
    },
    activity : this.navParams.get('activity'),
  };
  map = mapboxgl.Map;
  
  
  constructor(
    public navCtrl            : NavController,
    public userApi            : User,
    public menuCtrl           : MenuController,
    public modalCtrl          : ModalController,
    public nav                : Nav,
    public navParams          : NavParams,
    public repositoryProvider : RepositoryMyRadiant,
    public activityProvider   : Me,
    public helper             : HelperMyRadiant,
    public viewCtrl           : ViewController,
    public events             : Events,
    public config             : Config,
    public camera             : Camera,
    public file               : File, 
    private fileChooser       : FileChooser,
    private base64            : Base64,
    private filepath          : FilePath,
    private geolocation       : Geolocation,
    private androidPermissions: AndroidPermissions,
    public alertCtrl          : AlertController,
    public api                : Api
    ) {
    this.config.set('backButtonText','Edit Activity');
    // this.getListType();
    mapboxgl.accessToken = 'pk.eyJ1IjoiaGFuYWZpcSIsImEiOiJjangwM2N6ZGkwZ2YzNDlwb2VueDFzYjdjIn0.gJa2aKbVqmJ-nAFn8lc1Xg';
  }

  
  ionViewWillEnter(){
    this.loading = this.helper.showLoading("Loading Map.....");
    this.data.preview_img = this.api.url + this.data.activity.foto;
    console.log(this.data.preview_img);
  }
  ionViewDidEnter(){
    console.log(this.data.activity);
    let latlong = this.data.activity.activity_coordinate.split('|');
    this.data.user.lat = latlong[0];
    this.data.user.lng = latlong[1];
    this.buildMap();
  }  

  buildMap() {
    // console.log(this.map);
    this.map = new mapboxgl.Map({
      container: 'map-edit-activity',
      style: this.data.style,
      attributionControl:false,
      zoom: 10,
      center: [this.data.user.lng, this.data.user.lat]
    });
    
    this.map.addControl(new mapboxgl.NavigationControl());
    this.map.on('load',() => {
      new mapboxgl.Marker({
        draggable: false
        }).setLngLat([this.data.user.lng, this.data.user.lat]).addTo(this.map);
        
      var el = document.createElement('div');
      el.className = 'marker';
      el.style.backgroundImage = 'url(https://placekitten.com/g/40/40/)';
      el.style.width = '40px';
      el.style.height = '40px';
      try{
        this.loading.dismiss();
      }catch(e){}
    })      
  }

  showCamera(){
    let me = this;
    const options: CameraOptions = {
      quality: 25,
      destinationType: this.camera.DestinationType.FILE_URI,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      saveToPhotoAlbum:true,
      sourceType: this.camera.PictureSourceType.CAMERA,
      cameraDirection:this.camera.Direction.FRONT
    }
    
    this.camera.getPicture(options).then((uri) => {
      this.setFile(uri);
      
    }, (err) => {
     // Handle error
    });
  }

  chooseFile(){
    let me = this;
    this.fileChooser.open()
      .then(uri => {
        this.setFile(uri);
      })
      .catch(e => console.log(e));
  }

  setFile(url){
    let me = this;
    me.data.activity.change_file = true;
    this.filepath.resolveNativePath(url).then(imageData => {
      me.data.preview_img = imageData;
      this.file.resolveLocalFilesystemUrl(imageData).then(file => {
        me.data.activity.file_name = file.name;
      })
      this.base64.encodeFile(imageData).then((base64File: string) => {
        me.data.activity.img_binary = base64File;
      }, (err) => {
        console.log(err);
      });
    })
    .catch(err => console.log(err));
  }

  submit(){
    let me = this;
    let options = {
      desc:"Are you sure you want to edit this Activity?",
      inputType:"",
      className:"swal-text-center"
    };
    this.helper.presentSwalConfirmation(options,() => {
      me.actSubmit();
    })
  }

  actSubmit(){
    this.loading = this.helper.showLoading("Processing Data...");
    this.activityProvider.upd_activity(this.data.activity).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
      if(resp.success){
        this.helper.presentSwal('Success','Your activity has ben updated','success');
        this.nav.pop();
      }
    },(err) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/activity/myactivity/ubah/page.ts